/* istanbul ignore file */

import { createUseStyles } from '@glu/theming';

export default createUseStyles(({ spacing: { unit } }) => ({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    marginTop: 5.625 * unit
  },
  singleCheckboxWrapper: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap'
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    fontSize: 2 * unit,
    margin: '0 !important' // gluOverride for h4
  },
  headerWrapper: {
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'baseline'
  },
  subHeader: {
    marginLeft: 5
  }
}));
